import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import fallback_img from "./img/fallback_img.jpg"
import loading_img from "./img/loadingImg.jpg"

import placeholderImg from "../img/thumbnailPlaceholder.png"
import { ChevronDown, ChevronRight, ChevronsLeftRightEllipsis, Heart, LayoutDashboard, Pencil, Play, ShoppingCart, Trash2 } from "lucide-react";
const CourseCard1MouseOver= ({appItem,item,sendBackPopUpItem,onMouseLeaveFire,deleteCourseFallback})=>{
    const dispatch = useDispatch();
           const user = useSelector((state)=>state?.user?.user);
     
const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const appId = useSelector((state)=>state?.app?.app?.ID);
const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);

    const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={``}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={``}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={``}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={``}
      />
    </div>
  );
};
return(<>
<div className="courseCard1OuterInn" onMouseLeave={()=>{onMouseLeaveFire()}} style={{position:"absolute",zIndex:"999999",top:"0px"}}>
{item?.typeLabel?<div className="courseCardAllTypeLabel">{JSON.parse(item?.typeLabel)?.post_title} </div>:""}
  {item?.typeLabel?<div className="courseCardAllStatusLabel">{JSON.parse(item?.statusLabel)?.post_title}</div>:""}
 
   <ImageFallFB  itemOuter={{}}
                  boxShadow={``}
                  src={placeholderImg}
                  border={``}
                  width={ 100
                  }
                  aspectRatio={
                    2/1.2
                  }
                  borderRadius={
                    {
                      value: 10,
                      resolution: "%",
                    }
                  }
                /> 
                    <div  className="courseCard1TopEditButtons"
><div  onClick={()=>{}}>
      <Link onClick={()=>{dispatch({
          type: "COURSEDATA",
          
          payload:item
        });
      
       dispatch({
      type: "APPDATA",
      
      payload:appItem
    }); 
    
      }} to={`/apps/${AppToken}/create/course-name`}>  <Pencil 
   strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="#ffffff" style={{padding:"4px",background:"rgba(144, 202, 249,0.8)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>
    </Link>
    </div> 
          
<Trash2  onClick={()=>{deleteCourseFallback(item)}}  strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#ffffff" style={{padding:"4px",background:"rgba(144, 202, 249,0.8)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/> 
 </div>
                <div className="courseCard1MiddleButtons">
                           <div className="courseCard1MiddleButtons">
             {item?.languageLabel? <div className="courseCardAllLanguageLabel">{JSON.parse(item?.languageLabel)?.post_title}</div>:""}
              {item?.difficultyLabel?<div className="courseCardAllDifficultyLabel">{JSON.parse(item?.difficultyLabel)?.post_title}</div>:""}
          
              </div> 

                   <div onClick={()=>{sendBackPopUpItem(item);}} className="courseCard1MiddleButtonsItem4 courseCard1MiddleButtonsItemTwo ">
                     <ChevronRight strokeWidth={1.75} size={20} color={"#777777"} /> </div> 
                     
                     </div>
                     <div className="CourseAllItemTitle">{item?.productName}</div>
</div>

</>)
}
export default CourseCard1MouseOver;